import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/navigation/Header';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const TimeMachineIntegrationHub = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm p-12 text-center">
          <div className="max-w-2xl mx-auto">
            <div className="mb-6">
              <Icon name="Zap" className="w-16 h-16 text-blue-600 mx-auto" />
            </div>
            
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Time Machine Integration Hub
            </h1>
            
            <p className="text-lg text-gray-600 mb-8">
              This dedicated integration hub is now part of the comprehensive Timesheet Management Portal. 
              Access all time machine integrations, biometric configurations, and sync settings from the main portal.
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
              <div className="flex items-start gap-4">
                <Icon name="Info" className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
                <div className="text-left">
                  <h3 className="font-semibold text-blue-900 mb-2">Available in Timesheet Management Portal</h3>
                  <ul className="text-sm text-blue-800 space-y-1">
                    <li>• Facial recognition system integration</li>
                    <li>• Fingerprint scanner configuration</li>
                    <li>• QR code/card access setup</li>
                    <li>• Automated sync scheduling</li>
                    <li>• Employee biometric registration</li>
                  </ul>
                </div>
              </div>
            </div>

            <Button
              onClick={() => navigate('/timesheet-management-portal')}
              className="inline-flex items-center gap-2 bg-blue-600 text-white hover:bg-blue-700 px-6 py-3"
            >
              <Icon name="ArrowRight" className="w-5 h-5" />
              Go to Timesheet Management Portal
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TimeMachineIntegrationHub;
